/* TODO 临时方案-后续将舍弃 */
import { get, post } from '@/api/request'
import store from '@/store'
export const Api = {
  getMenuList: '/service-eipportal/sys/sysMenu/v1/getCurrentUserMenu',
  getLogoFile: '/service-eipportal/system/file/v1/getLogoFile',
  filePreview: '/service-eipportal/system/file/v1/preview',
  getFileById: '/service-eipportal/file/onlinePreviewController/v1/getFileById_',
  auth: '/service-eipauth/auth',
  ssoAuth: '/service-eipauth/sso/auth',
  refreshToken: '/service-eipauth/refresh',
  getTenant: '/service-eipuc/uc/tenantManage/v1/getTenantByCode',
  getUserDetail: '/service-eipuc/api/user/v1/user/getDetailByAccountOrId',
  getUserInfo: '/service-eipuc/api/user/v1/user/getByAccount',
  logout: '/service-eipauth/signout',
  ssoConfig: '/service-eipuc/api/systemConfig/v1/getSytemConfigUrl',
  jzAuthApi: '/service-eipauth/sso/auth/jz'
}

// 菜单
export const getMenuListApi = (params) => get(Api.getMenuList, params)

// 登录系统
export const authApi = (params) => post(Api.auth + '?tenantId=' + store.state.sys.tenantId, params)

// 登录系统
export const ssoAuthApi = (params) => get(Api.ssoAuth, params)

// 金智认证
export const jzAuthApi = (params) => get(Api.jzAuthApi, params)

// 刷新token
export const refreshTokenApi = (params) => get(Api.refreshToken, params)

// 获取租户
export const getTenantApi = (params) => get(Api.getTenant, params)

// 获取用户详情
export const getUserDetailApi = (params) => post(Api.getUserDetail, params)

// 文件预览
export const filePreviewApi = (params) => get(Api.filePreview, params, { responseType: 'blob' })

// 获取当前登录用户的信息
export const getUserInfo = (params) => post(Api.getUserInfo, params)

// 获取当前登录登出配置
export const getSSOConfig = () => get(Api.ssoConfig)

// 登出系统
export const logout = () => get(Api.logout)